import { useQuery } from '@tanstack/react-query'
import { MAIN_REJESTR_API_SHORT } from '../../../../components/utils/consts.js'
import { getItem } from '../../../app/getters/getItem.js'
import { useSelector } from 'react-redux'

export const useProjektData = (id, enabled) => {
    const role = useSelector((state) => state.user.role)
    const rolePrefix = role === 'oper' ? 'oper/' : ''
    return useQuery({
        queryKey: [`projekt__${id}`, id],
        queryFn: async () =>
            getItem(`/${rolePrefix}${MAIN_REJESTR_API_SHORT}/${id}`),
        refetchOnMount: 'always',
        enabled,
    })
}
